import { useQuery } from 'data-fetching-client';
import { AdEntityTypeToIdProperty, GET_ADS_PROPERTY_VALUES } from 'flow-doctor-lib/queries/AdsQueries';
export const getSearchTermValuesForAdFilter = (filter, adProperty, objectPropertiesByTermId) => {
  if (adProperty.options.length) {
    return filter.searchTerms.map(term => {
      const matchingEnumOption = adProperty.options.find(option => option.value === term);
      return matchingEnumOption ? matchingEnumOption.label : term;
    });
  }

  // Optional chaining would be reaaally nice here..
  return filter.searchTerms.map(term => objectPropertiesByTermId && objectPropertiesByTermId[term] && objectPropertiesByTermId[term].hs_name ? objectPropertiesByTermId[term].hs_name.value : term);
};
const useAdsFilterValues = ({
  portalId,
  adNetwork,
  entityType,
  ids
}, {
  skip
}) => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_ADS_PROPERTY_VALUES, {
    variables: {
      portalId,
      adNetwork,
      entityType,
      ids
    },
    skip
  });
  const dataToReturn = (() => {
    if (data) {
      return ids.reduce((acc, id) => {
        const matchingObject = data.adsPropertyValues.results.find(obj => obj.properties[AdEntityTypeToIdProperty[entityType]].value === id);
        if (matchingObject) {
          return Object.assign({}, acc, {
            [id]: matchingObject.properties
          });
        }

        // Non-matching search values get dropped
        return acc;
      }, {});
    }
    return null;
  })();
  return {
    data: dataToReturn,
    loading,
    error
  };
};
export default useAdsFilterValues;